export type ImpactSeverity = 'substantive' | 'minor'

/**
 * Normalized (trim + lowercase) producer impacts treated as low-severity. The
 * single place to tune; the producer vocabulary is open, so anything not listed
 * here is shown at full emphasis.
 */
const MINOR_IMPACTS: ReadonlySet<string> = new Set(['layout'])

export function impactSeverity(impact: string | null): ImpactSeverity {
  if (impact === null) return 'substantive'
  return MINOR_IMPACTS.has(impact.trim().toLowerCase())
    ? 'minor'
    : 'substantive'
}
